module.exports = __webpack_public_path__ + "static/media/user.085956c8.png";